export default __webpack_public_path__ + "static/media/joyce_headshot_bnw.69acd909.png";